import React, { useEffect } from 'react'
import { useFlags, useFlagsmith } from 'flagsmith/react'
import { featureFlags, traits } from 'domain/constants/featureFlags'
import { getAgencyPermissionsInformation, getAgencyInformation } from 'shared/infrastructure/storage'
import { CustomCard, Modal } from 'shared/ui'
import { Routes } from '../../../../../config/routes'
import { NewProposalTitle } from '../Home.styles'

const ProductsModal = () => {
  const permissions = getAgencyPermissionsInformation()
  const company = getAgencyInformation()
  const flagsmith = useFlagsmith();
  const flags = useFlags([featureFlags.NEW_HOME_EQUITY_LEADFORM])
  const flagsmithIdentity = flagsmith.identity

  useEffect(async () => {
    if (flagsmithIdentity) {
      await flagsmith.setTrait(traits.COMPANY_SOURCE, company?.source)
    }
  }, [company?.source, flagsmithIdentity])

  return (
    <Modal data-testid="products-modal">
      <NewProposalTitle data-testid="products-modal-title">
        Qual é o tipo de crédito da nova proposta?
      </NewProposalTitle>
      {permissions.HOME_FIN && (
        <CustomCard
          data-testid="home-fin-card"
          title="🎉 Financiamento de imóvel"
          subtitle="Financiamento imobiliário de 98 mil a 60 milhões"
          linkTo={Routes.LeadForm.HomeFinancing}
        />
      )}
      {permissions.HOME_REFI && (
        <CustomCard
          data-testid="home-card"
          title={
            <>
              Imóvel em garantia -{' '}
              <span style={{ fontWeight: 'bold' }}>Pessoa Física</span>
            </>
          }
          subtitle="Empréstimo de 50 mil a R$ 3 milhões"
          linkTo={flags[featureFlags.NEW_HOME_EQUITY_LEADFORM]?.value === 'on' ? Routes.LeadForm.NewHome : Routes.LeadForm.Home}
        />
      )}

      {permissions.AUTO_REFI && (
        <CustomCard
          data-testid="auto-card"
          title="Veículo em garantia"
          subtitle="Empréstimo de 5 mil a R$ 150 mil"
          linkTo={Routes.LeadForm.Auto}
        />
      )}
    </Modal>
  )
}

export { ProductsModal }
